import React from 'react'
import { withTranslation } from 'react-i18next'
import Input from 'components/Input'
import { UilArrowLeft } from '@iconscout/react-unicons'
import Btn, { FormBtn } from 'components/Btn'

  

export default withTranslation()(function ForgotPasswordForm({t, yupFields: { isDirty, isValid }}) {



  return (
    <div className="w-full mt-20">
      <Btn 
        content={() => <p className="text-primary flex font-semibold items-center"><UilArrowLeft size={18} className="mr-1" /> { t('misc.back') }</p>}
        className="mb-5" click={()=>window.history.back()}
      />
      
      <label className="text-2xl mb-2 block font-bold">{t('registration.forgot_password.title')}</label>
      <p className="text-secondary mb-8">{t('registration.forgot_password.content')}</p>
      
      <div className="py-3 mb-8">
        <Input
          name="email"
          label={t('registration.field.email')}
          type="email"
          labelwithin={true}
        />
      </div>

      <FormBtn
        content={ t('misc.submit')}
        className="w-36 h-12 rounded-xl text-white bg-primary hover:bg-primary"
        disabled={ !isValid || !isDirty }
      />

    </div>
  )
})